module.exports = __webpack_public_path__ + "img/icon-calendar.2ac0f32.svg";